import React from 'react';

import gallery1 from '../../assets/img/destination-galler/destination-gallery-1-1.png';
import gallery2 from '../../assets/img/destination-galler/destination-gallery-1-2.png';
import gallery3 from '../../assets/img/destination-galler/destination-gallery-1-3.png';
import foodImg from '../../assets/img/Food.webp';
import gallery5 from '../../assets/img/destination-galler/destination-gallery-1-5.png';

const Gallery = () => {
    const galleryImages = [
        {
            id: 1,
            image: gallery1,
            title: "Destination Gallery-1"
        },
        {
            id: 2,
            image: gallery2,
            title: "Destination Gallery-2"
        },
        {
            id: 3,
            image: gallery3,
            title: "Destination Gallery-3"
        },
        {
            id: 4,
            image: foodImg,
            title: "Food Experience"
        },
        {
            id: 5,
            image: gallery5,
            title: "Destination Gallery-5"
        }
    ];

    return (
        <div className="vs-destination-gallery-style1 overflow-hidden">
            <div className="row destination-gallery">
                <div className="col-lg-6 p-0">
                    <div className="destination-gallery-box h-100">
                        <img
                            src={galleryImages[0].image}
                            alt={galleryImages[0].title}
                            className="w-100 h-100"
                        />
                        <div className="icon-box">
                            <a href={galleryImages[0].image} title={galleryImages[0].title}>
                                <i className="fa-solid fa-eye"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="row">
                        {galleryImages.slice(1).map((image) => (
                            <div key={image.id} className="col-sm-6 p-0">
                                <div className="destination-gallery-box h-100">
                                    <img
                                        src={image.image}
                                        alt={image.title}
                                        className="w-100 h-100"
                                    />
                                    <div className="icon-box">
                                        <a href={image.image} title={image.title}>
                                            <i className="fa-solid fa-eye"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gallery;